import { createContext, Dispatch } from 'react';

import { PlayerReducerActionPayload } from './PlayerProvider.types';

export const PlayerDispatchContext = createContext<Dispatch<PlayerReducerActionPayload>>(null);
